import { createFileRoute } from '@tanstack/react-router';

import { MapView } from '@/components/map/components/MapView';
import { validateMapSearch } from '@/components/map/utils/mapUrlState';

export const Route = createFileRoute('/find-and-fix/network-overview')({
    validateSearch: validateMapSearch,
    component: NetworkOverviewPage,
});

function NetworkOverviewPage() {
    return (
        <div className="absolute inset-0 overflow-hidden">
            <MapView mode="find-and-fix" />
        </div>
    );
}
